import { CHART_COLORS } from '../../../../component/common/designSystem';

/**
 * Colours and route paths for the Guided Path section.
 *
 * Two kinds of plan, one colour each, kept the same on every chart they appear
 * in. With only two series the temptation is to let each panel pick its own
 * pair; that is exactly how a reader ends up comparing the AI line on one chart
 * with the custom line on the next.
 */
export const PLAN_COLORS = {
  ai: CHART_COLORS.brand, // the brand colour — the AI plan is the flagship
  custom: CHART_COLORS.teal
};

export const PLAN_ORDER = ['ai', 'custom'];

export const PLAN_LABELS = {
  ai: 'AI Plan',
  custom: 'Custom Plan'
};

/** URL segment per kind, so the tab strip and the fetchers cannot disagree. */
export const PLAN_PATHS = {
  ai: 'ai-plan',
  custom: 'custom-plan'
};

export const PLAN_BY_PATH = Object.fromEntries(
  Object.entries(PLAN_PATHS).map(([key, path]) => [path, key])
);

export const planColor = (key) => PLAN_COLORS[key] || CHART_COLORS.gray;

export const PLAN_RAMP = PLAN_ORDER.map((key) => PLAN_COLORS[key]);

/** AI only → custom only → both, deepening as involvement grows. */
export const BREADTH_RAMP = [CHART_COLORS.brand, CHART_COLORS.teal, CHART_COLORS.greenDeep];

/** Ordered bands — few days to many, cool to warm. */
export const ACTIVITY_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.blue,
  CHART_COLORS.brand,
  CHART_COLORS.greenDeep,
  CHART_COLORS.green
];

/** How long somebody has had a plan. Newest first, so it starts light. */
export const TENURE_RAMP = [
  CHART_COLORS.brandSoft,
  CHART_COLORS.blue,
  CHART_COLORS.brand,
  CHART_COLORS.moss,
  CHART_COLORS.gray
];

/**
 * Minutes a day people said they could commit. Deliberately NOT a red-to-green
 * ramp: somebody choosing fifteen minutes has not failed at anything, and a
 * colour scale that reads as a grade would turn a diary constraint into a
 * judgement.
 */
export const MINUTE_RAMP = [
  CHART_COLORS.teal,
  CHART_COLORS.blue,
  CHART_COLORS.brand,
  CHART_COLORS.pink,
  CHART_COLORS.orange
];

export const WEEKDAY_COLOR = CHART_COLORS.brand;
